/* Meeras Organics — shared scroll-reveal for story/specs/quote/gallery/cta sections. */
(function () {
  if (window.__meerasRevealInit) return;
  window.__meerasRevealInit = true;

  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("meeras-in")),
    { threshold: 0.18 }
  );
  document.querySelectorAll("[data-meeras-reveal]").forEach((el) => io.observe(el));

  function revealNow() {
    document.querySelectorAll("[data-meeras-reveal]:not(.meeras-in)").forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) el.classList.add("meeras-in");
    });
  }
  addEventListener("scroll", revealNow, { passive: true });
  revealNow();
})();
